import { patientRegisterActions } from '../../../../actions/user/patient/auth/register';

// Define the initial state for patient registration
const initialState = {
  loading: false,
  patientData: null, // Holds patient data after successful registration
  error: null // Holds error message if registration fails
};

// The reducer function
const patientRegisterReducer = (state = initialState, action) => {
  switch (action.type) {
    case patientRegisterActions.REGISTER_PATIENT.REQUEST:
      return {
        ...state,
        loading: true, // Set loading to true when the registration request is made
        error: null // Clear any previous errors
      };

    case patientRegisterActions.REGISTER_PATIENT.SUCCESS:
      return {
        ...state,
        loading: false, // Registration is complete
        patientData: action.payload, // Store the patient data returned by the API
        error: null // Clear any previous errors
      };

    case patientRegisterActions.REGISTER_PATIENT.FAILURE:
      return {
        ...state,
        loading: false, // Registration failed, loading is false
        error: action.payload // Store the error message from the failure
      };

    case patientRegisterActions.REGISTER_PATIENT.RESET:
      return {
        ...state,
        loading: false,
        patientData: null,
        error: null // Reset the state, clearing patient data and errors
      };

    default:
      return state;
  }
};

export default patientRegisterReducer;
